"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../utilities/ServiceFetch"));
var exceptions_1 = require("@ikea-aoa/exceptions");
var DEFAULT_CONFIGURATION_VERSION = '1.0';
/**
 * This class is used for saving planner configurations to the IKEA VPC service.
 */
var DexfVpcService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.dexfApplicationId DEXF application ID.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF API key.
     * @param [options.dexfConfigurationVersion] Configuration version. Defaults to "1.0".
     */
    function DexfVpcService(options) {
        this.dexfConfigurationVersion = '1.0';
        this.dexfApplicationId = null;
        this.dexfApiKey = null;
        this.endpoint = null;
        this.dexfApplicationId = options.dexfApplicationId;
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
        this.dexfConfigurationVersion =
            options.dexfConfigurationVersion || DEFAULT_CONFIGURATION_VERSION;
    }
    /**
     * Saves a planner configuration.
     *
     * @param configuration Configuration to save.
     * @param shoppingItems Product items.
     * @param [configurationImage] Configuration image as a base 64 string (e.g. "data:image/jpeg;base64,abc..").
     * @returns Promise object.
     */
    DexfVpcService.prototype.saveConfiguration = function (configuration, shoppingItems, configurationImage) {
        return __awaiter(this, void 0, void 0, function () {
            var response, configurationResponse, imageResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            method: 'POST',
                            body: this.getRequestBody(configuration, shoppingItems),
                            credentials: 'same-origin',
                            headers: {
                                'dexf-api-key': this.dexfApiKey,
                                'content-type': 'application/json'
                            }
                        })];
                    case 1:
                        response = _a.sent();
                        if (!(response && response['configurationId'])) return [3 /*break*/, 6];
                        configurationResponse = {
                            configurationId: response['configurationId'],
                            configurationVersion: this.dexfConfigurationVersion,
                            application: this.dexfApplicationId,
                            configuration: configuration,
                            imageUrl: null
                        };
                        if (!configurationImage) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.saveImage(response['_links']['main-design-image'].href, configurationImage)];
                    case 3:
                        imageResponse = _a.sent();
                        if (imageResponse && imageResponse['url']) {
                            return [2 /*return*/, __assign(__assign({}, configurationResponse), { imageUrl: imageResponse['url'] })];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error(new exceptions_1.ServiceException('Failed to save image. Error: ' + error_1));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, configurationResponse];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Save image to vpc dexf.
     *
     * @param url Configuration save vpc image url.
     * @param configurationImage Configuration image.
     * @returns Promise object.
     */
    DexfVpcService.prototype.saveImage = function (url, configurationImage) {
        return ServiceFetch_1.default.json(url, {
            method: 'POST',
            body: configurationImage,
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey,
                'content-type': 'text/plain;charset=UTF-8'
            }
        });
    };
    /**
     * Fetches and returns a planner configuration.
     *
     * @param id Configuration ID (VPC Code).
     * @returns Promise object.
     */
    DexfVpcService.prototype.getConfiguration = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.endpoint + '/' + id.toUpperCase();
                        return [4 /*yield*/, ServiceFetch_1.default.json(url, {
                                credentials: 'same-origin',
                                headers: {
                                    'dexf-api-key': this.dexfApiKey
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        if (response && response['configurationId']) {
                            return [2 /*return*/, {
                                    configurationId: response['configurationId'],
                                    configurationVersion: response['configuration'].version,
                                    application: response['application'].toUpperCase(),
                                    configuration: response['configuration'].content,
                                    imageUrl: response['image'],
                                    itemList: ((_a = response['itemList']) === null || _a === void 0 ? void 0 : _a.item) ? this.getItemList(response['itemList'].item) : null
                                }];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Return a list of shopping items.
     *
     * @param itemList ItemList.
     * @param itemList.itemType ItemType.
     * @param itemList.itemNo ItemNo.
     * @param itemList.quantity Quantity.
     */
    /**
     * @param itemList
     */
    DexfVpcService.prototype.getItemList = function (itemList) {
        return itemList.map(function (item) {
            return ({
                id: item.itemNo,
                type: item.itemType,
                quantity: item.quantity
            });
        });
    };
    /**
     * Returns payload to be used when saving a configuration.
     *
     * @param configuration Configuration to save.
     * @param shoppingItems Product items.
     * @returns Parsed data.
     */
    DexfVpcService.prototype.getRequestBody = function (configuration, shoppingItems) {
        return JSON.stringify({
            application: this.dexfApplicationId,
            itemList: {
                item: shoppingItems.map(function (item) {
                    return { itemType: item.type, itemNo: item.id, quantity: item.quantity };
                })
            },
            configuration: {
                version: this.dexfConfigurationVersion,
                content: configuration
            }
        });
    };
    return DexfVpcService;
}());
exports.default = DexfVpcService;
//# sourceMappingURL=DexfVpcService.js.map